import {urlPath} from '@/utils'

/**
 * define list page is non logged in
 * It includes:
 *    - login page
 * @type {{path: string, name: string}[]}
 */
export const NON_LOGGED_IN_PAGES = [urlPath.LOGIN]
